import {combineReducers} from 'redux'
import {ice} from 'icepath'
import {uiReducer,makeActionCreator,reducerCreator, postFetcher, getFetcher,arrToMap} from 'startlibs'
import {reportReducers, propsToStoreState} from 'report-components/lib/reducers'

export const formPutFetch = makeActionCreator('FORM_FETCH', (s) => s, (obj, {url}) => postFetcher(url, obj,{method:"PUT"}))

export const unlinkWorkstation = makeActionCreator("UNLINK_WORKSTATION",(chain,_,{_payload:id})=>chain.unset(id).filterIn(['order'],_=>_!==id), (id) => getFetcher('/api/station-tokens/'+id,{},{method:'DELETE'}))
export const unlinkAllWorkstations = makeActionCreator("UNLINK_ALL_WORKSTATIONS",()=>ice({order:[]}),() => getFetcher('/api/clear-station-tokens/',{},{method:'DELETE'}))
export const loadWorkstations = makeActionCreator("LOAD_WORKSTATIONS",(chain,resp)=>ice(arrToMap(resp,"id")), () => getFetcher('/api/station-tokens'))
const workstationsReducer = reducerCreator({},[unlinkWorkstation,unlinkAllWorkstations,loadWorkstations])

const addNewReports = (chain, response, {_payload:{page, query, sort}}) => {
  if (response.first) {
    return ice(arrToMap(response.content,"uid")).assign({'finished':response.last,'totalPages':response.totalPages, total: response.totalElements,page: 0, query, sort})
  } else {
    const {order,...values} = arrToMap(response.content,"uid")
    return chain.push('order',...order).assign(values).set('finished',response.last).set('page',page)
  }
}

export const loadReports = makeActionCreator("LOAD_REPORTS", addNewReports,(params = {size:40,page:0,sort:'last_Saved,desc'}) => getFetcher('/api/reports',params))
export const deleteReport = makeActionCreator("DELETE_REPORT",(chain,_,{_payload:id})=> chain.unset(id).filterIn(['order'],_=>_!==id).updateIn('total',(i)=>i-1), (id) => getFetcher('/api/report/'+id,{},{method:'DELETE'}))
const reportsReducer = reducerCreator({},[loadReports,deleteReport])

export const signIn = makeActionCreator("SIGN_IN",(chain,result)=>ice(result))
export const getAccount = makeActionCreator("GET_ACCOUNT",(chain,result)=>ice(result), () => getFetcher('/api/account'))
export const setProfile = makeActionCreator("SET_PROFILE",(chain,_,{_payload:{firstName,lastName,picture}})=>chain.assign({hasProfile:true,firstName,lastName,picture}), (form) => postFetcher('/api/profiles',form))
export const logout = makeActionCreator("LOGOUT",()=>ice({}), () => getFetcher("/api/logout"))
export const userSubscriptionSuccess = makeActionCreator("SUBSCRIPTION_SUCCESS",(chain,_,{_payload})=>chain.set('accountStatus','active').set('stripeCardAdded',true).set('authorities',_payload))
export const cancelSubscription = makeActionCreator("CANCEL_SUBSCRIPTION",(chain)=>chain, (subscriptionType) => postFetcher('/api/cancel-subscription',{subscriptionType}))
const userReducer = reducerCreator({},[signIn,getAccount,setProfile,logout,cancelSubscription,userSubscriptionSuccess])

export const clearNotifications = makeActionCreator('CLEAR_NOTIFICATIONS', (chain) => ice([]))
export const setNotifications = makeActionCreator('SET_NOTIFICATIONS', (chain,notification) => ice(notification))
const notificationReducer = reducerCreator([], [clearNotifications,setNotifications])

export const setReport = makeActionCreator('SET_REPORT',undefined, (id) => getFetcher('/api/report-json/'+id))

export const deleteFetch = makeActionCreator('DELETE_FETCH', (s) => s, (obj, {url}) => postFetcher(url, obj, {method: "DELETE"}))

export const reducers = combineReducers({
  report: (state,action) => {
    if (action.type === setReport.toString()) {
      state = propsToStoreState(ice.set(action.payload,'userEmail',ice.get(action,['meta','ownProps','userEmail'])))
    }
    return reportReducers(state,action)
  },
  reports: reportsReducer({
    [logout]:()=>ice({})
  }),
  workstations: workstationsReducer({
    [logout]:()=>ice({})
  }),
  user: userReducer(),
  appUI:uiReducer({
    notifications: notificationReducer({
      [setProfile]:(chain,_,meta) => meta._dontFetch ? chain : ice(["Changes saved successfully"])
    })
  })
})



// WEBPACK FOOTER //
// ./src/javascripts/reducers/index.jsx